<template>
  <div class="main-content">
    <!-- Page Header Start -->
    <PageHeader
      :isAssessmentBarRemoved="true"
    >
      <PageHeaderTitleContent>
        <TitleTextContent 
          :titleText="'Cyber Self Assessments'" 
          :subTitleText="'If you are handling Controlled Unclassified Information (CUI) or Federal Contract Information (FCI) on your network or information systems, there are compliance standards you are required to meet. Taking one of our Cyber Self Assessments will help you determine your current level of security based on NIST 800-171, CMMC Level 1, and CMMC Level 2 requirements. These self assessments serve as a great first step in your cybersecurity journey. Need more help? Click the yellow question mark in the bottom right-hand corner of the webpage to have a Cyber Advisor contact you.'"
        />
        <div style="min-width: 430px;" class="action-handler my-3 my-md-0 my-lg-0 my-xl-0 px-4">
          <div v-if="isLoggedIn" style="max-height: 120px;" class="d-flex flex-column flex-md-row flex-lg-row flex-xl-row align-items-center justify-content-center">
            <!-- <v-btn
              rounded
              large
              dark
              :color="primaryButtonColor"
              width="220"
              class="ml-0"
              @click="scrollToAssessmentSection"
            >
              Test Your Knowledge
            </v-btn> -->

              <!------ TEMPORARILY COMMENTED OUT THIS BUTTON UNTIL THE DASHBOARD IS READY --------->
              <!-- <v-btn
                  outlined
                  rounded
                  :color="'#fff'"
                  width="200"
                  @click="''"
              >
                Check Dashboard
              </v-btn> -->
            </div>

            <div v-else style="max-height: 120px; gap: 25px;" class="d-flex flex-column flex-md-row flex-lg-row flex-xl-row align-items-center justify-content-between">
              <router-link
                :to="{ name: 'signup' }"
              >
                <v-btn
                  rounded
                  large
                  dark
                  :color="'#424EC4'"
                  width="180"
                  @click="() => activateSelectedNameMenuItem('Sign In/Register')"
                >
                  Register
                </v-btn>
              </router-link>

              <router-link
                :to="{ name: 'login', query: { redirect: this.$route.path } }"
              >
                <v-btn
                  rounded
                  outlined
                  large
                  dark
                  :color="'#ffffff'"
                  width="180"
                  @click="() => activateSelectedNameMenuItem('Sign In/Register')"
                >
                  Log In
                </v-btn>
              </router-link>
            </div>
        </div>
      </PageHeaderTitleContent>
    </PageHeader>
    <!-- Page Header End -->

    <!-- Body Area Start-->
    <section id="assessment-section" v-if="isLoggedIn" class="section section-content p-0 mt-5 mb-4 d-flex justify-content-center">
      <div :class="containerBox" class="container-box">
        <!-- <div>
          <div class="text-center mb-2 text-font text-title">CYBER SELF ASSESSMENT</div>
          <h2 class="text-center text-font text-header mb-2 mb-md-3 mb-lg-4 mb-xl-4">How secure is your organization?</h2>
          <p class="m-0 mt-4 mt-md-0 mt-lg-0 mt-xl-0 text-center text-description">
            Select the NIST 800-171 or CMMC Readiness Checks to assess your readiness to meet the requirements.
          </p>
        </div> -->
        <div>
          <div class="row m-0 mb-5">
            <div class="col-12 p-0 d-flex flex-column align-items-center assessment-items">
              <div class="container-fluid m-0 p-0 assessment-item" v-for="asmt in assessments" :key="asmt.key">
                <div class="h-100 row m-0">
                  <div class="col-12 col-md-3 col-lg-3 col-xl-3 p-0 d-flex justify-content-center align-items-center">
                    <div class="assessment-item-title text-center text-md-left text-lg-left text-xl-left">
                      {{ asmt.title }}
                    </div>
                  </div>
                  <div class="col-12 col-md-9 col-lg-9 col-xl-9 p-0 assessment-item-task">
                    <div class="container-fluid m-0 p-0 h-100">
                      <div class="row m-0 h-100">
                        <div class="col-12 col-md-8 col-lg-8 col-xl-8 p-3 p-md-0 p-lg-0 p-xl-0 d-flex justify-content-center align-items-center">
                          <div class="assessment-item-description text-center text-md-left text-lg-left text-xl-left">
                            {{ asmt.description }}
                          </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4 col-xl-4 p-0 d-flex justify-content-center align-items-center">
                          <div class="w-100 h-auto text-center text-lg-left text-xl-left p-3 p-sm-0 p-md-0 p-lg-0 p-xl-0">
                            <router-link
                              :to="{
                                name: 'cyber-readiness-check-tool',
                                params: { toolKey: asmt.key },
                              }"
                            >
                              <v-btn
                                  class="button-class px-lg-5 px-xl-5"
                                  rounded
                                  :color="primaryButtonColor"
                                  height="60"
                              >
                                {{ assessmentKeys[asmt.key].title }}
                              </v-btn>
                            </router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Body Area Start-->

  </div>
</template>
<script>
import axios from "axios"
import { isLoggedIn } from "../../utils/authentication"
import PageHeader from "../library/widgets/page-header.vue";
import PageHeaderTitleContent from "../library/widgets/page-header-title-content.vue";
import TitleTextContent from "../library/widgets/title-text-content.vue";
import { EventBus } from "../../utils/eventBus";

export default {
  data() {
    return {
      assessments: [],
      assessmentKeys: {
        // NEWCMMCLEVEL1SCOPING: {
        //   color: "#424EC4", 
        //   title: "Start Questionnaire"
        // },
        NEWCMMCLEVEL1: {
          color: "#00AFF7", 
          title: "Start Assessment",
          textColor: "#001426"
        },
        NEWCMMCLEVEL2: {
          color: "#00AFF7", 
          title: "Start Assessment",
          textColor: "#001426"
        },
        // NEWNIST800171: {
        //   color: "#FF504D", 
        //   title: "Start Assessment"
        // },
        // NEWCMMCLEVEL2SCOPING: {
        //   color: "#000000", 
        //   title: "Start Questionnaire"
        // },
      },
    }
  },
  components: {
    PageHeader,
    PageHeaderTitleContent,
    TitleTextContent,
  },
  mounted() {
    this.activateSelectedNameMenuItem("Resources");

    this.computeHeaderBannerHeight();
    window.addEventListener('resize', this.computeHeaderBannerHeight);
  },
  destroyed(){
    window.removeEventListener('resize', this.computeHeaderBannerHeight);
  },
  computed: {
    isLoggedIn() {
      return isLoggedIn()
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm;
    },
    containerBox() {
      if (this.$vuetify.breakpoint.xs) {
        return "container-box-xs";
      }
      else if(this.$vuetify.breakpoint.sm) {
        return "container-box-sm";
      }
      else if(this.$vuetify.breakpoint.md) {
        return "container-box-md";
      }
      return "container-box-lg-xl";
    }
  },
  created() {
    this.loadAssessments()
  },
  methods: {
    init() {
      /* The footer height no longer needs to be set */
      // this.initFooterHeight();
    },
    initFooterHeight() {
      var footerHeight = $("footer").outerHeight()
      $(".main-content").css("margin-bottom", footerHeight)
    },
    scrollToAssessmentSection() {
      document
        .getElementById("assessment-section")
        .scrollIntoView({ behavior: "smooth" });
    },
    async loadAssessments(tool) {
      /*  API call to assessment/schema */
      axios.get("/api/assessment/schema/").then((response) => {
        // Filter assessments to only include those that have corresponding entries in assessmentKeys
        this.assessments = response.data.filter(asmt => this.assessmentKeys[asmt.key]);
        this.setStatesOfScopingAssessments();
      })
    },
    async setStatesOfScopingAssessments() {
      // axios
      //   .post("/api/assessment/user/response/", {
      //     network_uuid: this.$store.getters.getUser.network_uuid,
      //     assessmentKey: "NEWCMMCLEVEL1",
      //   })
      //   .then((response) => {
      //     var res = {}
      //     if (response.data.Count != 0) {
      //       res = response.data.Items[0].answers
      //       if (res.progress <= 0) {
      //         //show scoping.
      //         axios
      //           .post("/api/assessment/user/response/", {
      //             network_uuid: this.$store.getters.getUser.network_uuid,
      //             assessmentKey: "NEWCMMCLEVEL1SCOPING",
      //           })
      //           .then((response1) => {
      //             var res1 = {}
      //             if (response1.data.Count != 0) {
      //               res1 = response1.data.Items[0].answers
      //               if (res1.progress != 100) {
      //                 //in complete , hide cmmc 2
      //                 $("#NEWCMMCLEVEL1").attr("disabled", "disabled")
      //               }
      //             } else {
      //               //in complete, hide cmmc 2
      //               $("#NEWCMMCLEVEL1").attr("disabled", "disabled")
      //             }
      //           })
      //       }
      //     }
      //   })
      axios
        .post("/api/assessment/user/response/", {
          network_uuid: this.$store.getters.getUser.network_uuid,
          assessmentKey: "NEWCMMCLEVEL2",
        })
        .then((response) => {
          var res = {}
          if (response.data.Count != 0) {
            res = response.data.Items[0].answers
            if (res.progress <= 0) {
              //show scoping.
              axios
                .post("/api/assessment/user/response/", {
                  network_uuid: this.$store.getters.getUser.network_uuid,
                  assessmentKey: "NEWCMMCLEVEL2SCOPING",
                })
                .then((response1) => {
                  var res1 = {}
                  if (response1.data.Count != 0) {
                    res1 = response1.data.Items[0].answers
                    if (res1.progress != 100) {
                      //in complete , hide cmmc 2
                      $("#NEWCMMCLEVEL2").attr("disabled", "disabled")
                    }
                  } else {
                    //in complete, hide cmmc 2
                    $("#NEWCMMCLEVEL2").attr("disabled", "disabled")
                  }
                })
            }
          }
        })
    },
    activateSelectedNameMenuItem(nameMenuItem){
      EventBus.$emit("activate-indicated-menu-item", nameMenuItem);
    },
    computeHeaderBannerHeight() {
      const navHeight = document.querySelector('nav').clientHeight;
      const footerHeight = document.querySelector('.v-footer').clientHeight;
      
      const heightRemainder = window.innerHeight - (navHeight + footerHeight);
      const pageHeaderElement = document.getElementById('page-header-row-container');

      pageHeaderElement.style.minHeight = isLoggedIn() 
                                            ? this.isMobile 
                                                ? '200px' : '445px'
                                            : `${heightRemainder + 16}px`;
    }
  },
}
</script>
<style scoped>
.privacy-link-footer {
  color: #007bff;
}

.action-handler .v-btn {
  padding-top: 25px;
  padding-bottom: 25px;
}

.assessment-items {
  gap: 25px;  
}
.assessment-item {
  min-height: 300px;
  background-color: #FFFFFF;
  border-radius: 5px;
  border: 2px solid rgba(0, 0, 0, 0.20);
}

.text-font {
  font-family: Rajdhani !important;
  font-style: normal;
  line-height: normal;
  font-weight: 600;
}
.text-title {
  font-size: 22px;
  color: #424EC4;
}
.text-header {
  font-size: 32px;
  color: #272727;
}
.text-description {
  font-family: Rajdhani;
  font-size: clamp(20px, 2vw, 24px);
  font-weight: 400;
  line-height: normal;
}

.container-box {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 40px;
}
.container-box-lg-xl {
  width: 75%;
}
.container-box-md {
  width: 80%;
}
.container-box-sm {
  width: 85%;
}
.container-box-xs {
  width: 90%;
}

.assessment-item-title, 
.assessment-item-description {
  color: #000;
  font-family: Rajdhani;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.container-box-lg-xl .assessment-item-title, 
.container-box-md .assessment-item-title {
  max-width: 120px;
}
.container-box-lg-xl .assessment-item-description, 
.container-box-md .assessment-item-description {
  width: 90%;
  max-width: 478px;
}

.container-box-sm .assessment-item-title, 
.container-box-xs .assessment-item-title {
  width: 100%;
  padding: 20px;
}
.container-box-xs .assessment-item {
  min-height: 70px;
}

.container-box-lg-xl .assessment-item-task, 
.container-box-md .assessment-item-task {
  border-left: 1px solid rgba(0, 0, 0, 0.20);
}
.container-box-sm .assessment-item-task, 
.container-box-xs .assessment-item-task {
  border-top: 1px solid rgba(0, 0, 0, 0.20);
} 

.button-class {
  width: 80%;
  border-radius: 40px;
  font-size: clamp(16px, 1vw, 24px);
  font-family: Rajdhani;
  font-weight: 700;
  color: #ffffff;
}
</style>
